<div id="main">
  <div class="fof">
    <img src="/assets/death-star.svg" >
    <h1>Error 404</h1>
    <h3>This is not the page you're looking for.</h3>
    <br>
    <button mat-raised-button color="accent" routerLink="/">Back Home</button>
  </div>
</div>
